import { Skeleton } from "@/components/ui/skeleton";

/**
 * The page's shape while the product loads.
 *
 * This is also what the prerendered HTML contains — the product is fetched in
 * an effect, so the static page must look like a page and not a blank.
 */
export function ProductSkeleton() {
  return (
    <main className="mx-auto max-w-7xl px-5 pt-28 pb-16 sm:px-8" aria-busy="true" aria-label="Memuat produk">
      <Skeleton className="h-4 w-20" />
      <div className="mt-6 grid gap-10 lg:grid-cols-[minmax(0,7fr)_minmax(0,5fr)]">
        <div className="flex flex-col gap-3 lg:flex-row-reverse">
          <Skeleton className="aspect-[4/3] flex-1 rounded-2xl" />
          <div className="flex gap-2 lg:w-20 lg:flex-col">
            <Skeleton className="size-20" />
            <Skeleton className="size-20" />
            <Skeleton className="size-20" />
          </div>
        </div>
        <div className="space-y-6">
          <Skeleton className="h-9 w-2/3" />
          <Skeleton className="h-5 w-1/2" />
          <Skeleton className="h-8 w-40" />
          <div className="space-y-3">
            <Skeleton className="h-5 w-40" />
            <div className="flex gap-3">
              <Skeleton className="size-11 rounded-full" />
              <Skeleton className="size-11 rounded-full" />
              <Skeleton className="size-11 rounded-full" />
            </div>
          </div>
          <div className="space-y-3">
            <Skeleton className="h-5 w-32" />
            <div className="grid grid-cols-3 gap-2">
              <Skeleton className="h-12" />
              <Skeleton className="h-12" />
              <Skeleton className="h-12" />
            </div>
          </div>
          <Skeleton className="h-12 w-full rounded-full" />
        </div>
      </div>
    </main>
  );
}
